<template>
  <el-dialog
    v-drag
    title="数据审核"
    :visible.sync="dialogVisible"
    width="1200px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <BaseTable
        ref="tableData"
        :height="440"
        :tableData="{
          ...tableData,
          fileds,
        }"
        :selectRows="selections"
        :isPager="false"
        @handleSelectionChange="handleSelectionChange"
      >
        <template slot="message" slot-scope="row">
          <el-tooltip
            v-if="row.scope.message"
            class="item"
            effect="dark"
            :content="row.scope.message"
            placement="top-start"
          >
            <i class="el-icon-warning" style="color: #fe453d" />
          </el-tooltip>
        </template>
      </BaseTable>
      <p class="tips">
        共选择
        <span style="color: #fe453d">{{ selections.length }}</span>
        条数据
      </p>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
import { importReceivable, importPayable } from '@/api/fee'
const BaseTable = () => import('@/components/table/BaseTable')

export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    fileData: {
      type: Array,
      default: function() {
        return []
      }
    },
    type: {
      type: Number,
      default: 0 // 0 应收 1 应付
    }
  },
  data() {
    return {
      tableData: {
        columns: [],
        mutiCheck: true,
        total: 0
      },
      loading: false,
      selections: []
    }
  },
  computed: {
    fileds() {
      if (!this.type) {
        return [
          {
            filed: 'message',
            label: '错误信息',
            width: '80',
            isCustom: true
          },
          {
            filed: 'mblNo',
            label: '提单号',
            width: ''
          },
          {
            filed: 'containerNo',
            label: '柜号',
            width: ''
          },
          {
            filed: 'feeName',
            label: '费用项',
            width: ''
          },
          {
            filed: 'qty',
            label: '个数',
            width: ''
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: ''
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ]
      } else {
        return [
          {
            filed: 'message',
            label: '错误信息',
            width: '80',
            isCustom: true
          },
          {
            filed: 'mblNo',
            label: '提单号',
            width: ''
          },
          {
            filed: 'containerNo',
            label: '柜号',
            width: ''
          },
          {
            filed: 'invoiceNumber',
            label: '账单',
            width: ''
          },
          {
            filed: 'supplierName',
            label: '供应商',
            width: ''
          },
          {
            filed: 'feeName',
            label: '费用项',
            width: ''
          },
          {
            filed: 'qty',
            label: '个数',
            width: ''
          },
          {
            filed: 'unitPrice',
            label: '单价',
            width: ''
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ]
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.tableData.columns = this.fileData
        this.$nextTick(() => {
          this.selections = this.fileData
          this.fileData.forEach((row) => {
            if (!row.message) {
              this.$refs.tableData.toggleRowSelection(row)
            }
          })
        })
      }
    }
  },
  created() {},
  methods: {
    async ok() {
      try {
        this.loading = true
        let res
        if (!this.type) {
            res = await importReceivable(this.tableData.columns)
        } else {
            res = await importPayable(this.tableData.columns)
        }
        this.loading = false
        if (res.success) {
          this.$emit('ok')
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
      this.tableData.columns = []
    },
    handleSelectionChange(item) {
      this.selections = item
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  .tips {
    height: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #77879e;
    line-height: 20px;
    margin-top: 20px;
  }
}
.footers {
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
